import {Link as RouterLink} from "react-router-dom";
import {Box, Flex, Icon, Image, Link} from "@chakra-ui/react";
import {BsFillCalculatorFill} from "@onemind-services-llc/react-icons-ng/bs";
import {FaHome} from "@onemind-services-llc/react-icons-ng/fa";
import {FcAbout} from "@onemind-services-llc/react-icons-ng/fc";
import {LuContact} from "@onemind-services-llc/react-icons-ng/lu";
import {TbOutlineReportMoney} from "@onemind-services-llc/react-icons-ng/tb";
import {Tooltip} from "../Components/ui/tooltip";
import {useCalculator} from "../context/calculatorContext/context";
import BucketAlert from "./bucketAlert";

const Header = () => {
  const {selectedData, setShowModal} = useCalculator();

  return (
    <Box
      position="sticky"
      top="0"
      zIndex="100"
      background={"white"}
      opacity={"1"}
      shadow={"sm"}
    >
      <Box
        pt="15px"
        pb="15px"
        pl={{base: "10px", sm: "5vw", lg: "15vw"}}
        pr={{base: "10px", sm: "5vw", lg: "15vw"}}
      >
        <Flex justifyContent={"space-between"} alignItems={"center"}>
          <Box display={"flex"} gap={10} alignItems={"center"}>
            <Tooltip content="CloudMyLab Resource Calculator" openDelay={0}>
              <Link as={RouterLink} to={"/"} data-cy="nav-logo">
                <Image width={"60px"} src={"/company.png"} />
              </Link>
            </Tooltip>
            <Box>
              <Tooltip content="CloudMyLab Resource Calculator" openDelay={0}>
                <Link as={RouterLink} to={"/"} data-cy="nav-link">
                  <Icon color="#1A5F7A" size="lg">
                    <FaHome />
                  </Icon>
                </Link>
              </Tooltip>
            </Box>
          </Box>
          <Box display={"flex"} alignItems={"center"} gap={3}>
            <Tooltip content="Resource Calculator" fontSize="md" openDelay={0}>
              <Link
                position={"relative"}
                onClick={() => setShowModal((prev) => prev + 1)}
                data-cy="nav-link"
              >
                <BsFillCalculatorFill
                  style={{
                    color: "#1A5F7A",
                    fontSize: "20px",
                    cursor: "pointer",
                  }}
                />
                <Box
                  position={"absolute"}
                  top={"-5px"}
                  right={"-2px"}
                  minW={selectedData.length < 100 ? "15px" : "17px"}
                  maxW={selectedData.length < 100 ? "15px" : "17px"}
                  minH={selectedData.length < 100 ? "15px" : "17px"}
                  maxH={selectedData.length < 100 ? "15px" : "17px"}
                  color={"white"}
                  fontWeight={"bold"}
                  background={"red"}
                  borderRadius={"50%"}
                  display={selectedData.length > 0 ? "inline-flex" : "none"}
                  alignItems={"center"}
                  justifyContent={"center"}
                  fontSize={"9px"}
                  data-cy="resource-calculator-quantity"
                >
                  {selectedData.length < 100 ? selectedData.length : "99+"}
                </Box>
              </Link>
            </Tooltip>

            <Tooltip content="Invoice" fontSize="md" openDelay={0}>
              <Link as={RouterLink} to={"/request"} data-cy="nav-link">
                <TbOutlineReportMoney
                  style={{
                    color: "#1A5F7A",
                    fontSize: "25px",
                  }}
                />
              </Link>
            </Tooltip>
            <Tooltip content="About Us" fontSize="md" openDelay={0}>
              <Link as={RouterLink} to={"/about"} data-cy="nav-link">
                <FcAbout
                  style={{
                    fontSize: "25px",
                  }}
                />
              </Link>
            </Tooltip>
            <Tooltip content="Contact Us" fontSize="md" openDelay={0}>
              <Link
                href={"https://cloudmylab.com/contact-us"}
                target="_blank"
                data-cy="nav-link"
              >
                <LuContact style={{color: "#1A5F7A", fontSize: "25px"}} />
              </Link>
            </Tooltip>
          </Box>
        </Flex>
      </Box>
      <BucketAlert />
    </Box>
  );
};

export default Header;
